import React from 'react';
import { WaitlistForm } from './WaitlistForm';
import { NewsletterForm } from './NewsletterForm';

export function WaitlistSection() {
  return (
    <section className="py-20 px-4 bg-white" id="waitlist-section">
      <div className="max-w-xl mx-auto space-y-12">
        <div>
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
            Sign Up for Early Access!
          </h2>
          <WaitlistForm />
        </div>
        <NewsletterForm />
      </div>
    </section>
  );
}